import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Previous in-app page (SPA history, or a same-site full page load such as a plain link), else the fallback list page.
export const goBack = (navigate, fallback = "/") => {
  if ((window.history.state?.idx ?? 0) > 0) return navigate(-1);
  let sameSite = false;
  try { sameSite = !!document.referrer && new URL(document.referrer).origin === window.location.origin && document.referrer !== window.location.href; } catch { /* bad referrer */ }
  if (sameSite && window.history.length > 1) return window.history.back();
  return navigate(fallback, { replace: true });
};

export default function BackButton({ fallback = "/", className = "inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-emerald-700", label = "Back", testid = "back-btn" }) {
  const navigate = useNavigate();
  return (
    <button type="button" onClick={() => goBack(navigate, fallback)} className={className} data-testid={testid}>
      <ArrowLeft className="w-4 h-4 rtl-flip" /> {label}
    </button>
  );
}
